export default __webpack_public_path__ + "static/media/about2.30e0b24e.svg";